/**
 * API client per health check.
 *
 * Endpoint:
 * - GET /health - Status servizi (DB, Redis, MinIO) + queue stats
 *   (Nota: l'endpoint e' al root del backend, non sotto /api/v1)
 */

import axios from 'axios';

export interface ServiceStatus {
  status: boolean;
  latency_ms: number | null;
  error: string | null;
}

export interface QueueStats {
  unassigned_cases: number;
  pending_cases: number;
  new_emails: number;
  last_processed_email: string | null;
  total_cases: number;
  total_emails: number;
  emails_with_summary: number;
  cases_with_vet: number;
  draft_emails: number;
}

export interface HealthResponse {
  status: string;
  version: string;
  timestamp: string;
  services: Record<string, ServiceStatus>;
  queue_stats: QueueStats | null;
}

const api = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth interceptor - adds Bearer token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor - handles 401 by redirecting to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const healthApi = {
  /**
   * Ottieni stato di tutti i servizi.
   */
  getHealth: async (): Promise<HealthResponse> => {
    const response = await api.get<HealthResponse>('/health');
    return response.data;
  },
};
